import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import fontAwesome from './plugins/fontawesome'
// 引入自定义样式
import './styles/variables.css'
import './styles/base.css'
import './styles/components.css'
// 打印环境变量
console.log('=== 应用启动 ===')
console.log('NODE_ENV:', process.env.NODE_ENV)
console.log('VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API)

// Fallback for old Android WebView: flex gap unsupported causes items to stick together.
const detectFlexGapSupport = () => {
  if (typeof document === 'undefined' || !document.body) {
    return true
  }

  const flex = document.createElement('div')
  flex.style.display = 'flex'
  flex.style.flexDirection = 'column'
  flex.style.rowGap = '1px'
  flex.style.position = 'absolute'
  flex.style.top = '-9999px'

  const child1 = document.createElement('div')
  child1.style.height = '1px'
  const child2 = document.createElement('div')
  child2.style.height = '1px'

  flex.appendChild(child1)
  flex.appendChild(child2)
  document.body.appendChild(flex)

  const isSupported = flex.scrollHeight === 3
  document.body.removeChild(flex)
  return isSupported
}

if (!detectFlexGapSupport()) {
  document.documentElement.classList.add('no-flex-gap')
}

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(fontAwesome)
app.mount('#app')

console.log('=== 应用挂载完成 ===')
